var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StyledSelect',{staticClass:"selector",attrs:{"data":_vm.wrappedSortOptions,"selected":_vm.selectedOption},on:{"select":_vm.onSortSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }